import React, { Fragment, useEffect } from 'react';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { TrackingHandler } from 'client/tracking/handler';
import { CommonMap } from 'client/tracking/maps/common';
import { BackToTop } from 'site-modules/shared/components/back-to-top/back-to-top';
import { GLOSSARY_BREADCRUMBS, GLOSSARY_CONTENT_PATH } from 'site-modules/glossary/constants/glossary';
import { GlossaryContent } from 'site-modules/glossary/components/glossary-content/glossary-content';

function GlossaryUI({ content = null }) {
  useEffect(() => {
    TrackingHandler.useMap(CommonMap);
  }, []);

  if (!content) {
    return null;
  }

  const { title } = content;
  const introductionContent = content.child('sub-page-1').child('sub-page-1-left-col').child('editorial-header');
  const termsContent = content
    .child('sub-page-1')
    .child('sub-page-1-left-col')
    .child('glossary-terms-container')
    .child('glossary-terms');

  return (
    <Fragment>
      <GlossaryContent
        breadcrumbsData={GLOSSARY_BREADCRUMBS}
        title={title}
        introductionContent={introductionContent.content}
        termsContent={termsContent.content}
      />
      <BackToTop />
    </Fragment>
  );
}

GlossaryUI.propTypes = {
  content: CmsEntities.Content,
};

export const Glossary = connectToModel(GlossaryUI, {
  content: bindToContent(`${GLOSSARY_CONTENT_PATH}.withContent`),
});
